import { c as _c } from "react/compiler-runtime";
import { CategoryIdentifier } from "@opensea/graphql";
import { toLowerCase, toUpperCase } from "@opensea/utils";
import { parseAsStringLiteral, useQueryState } from "nuqs";
import { QUERY_PARAM_KEYS } from "./keys";
const parser = parseAsStringLiteral(CategoryIdentifier.map(value => toLowerCase(value)));
export function useCategoryQueryParam() {
  const $ = _c(7);
  const [category, setCategory] = useQueryState(QUERY_PARAM_KEYS.category, parser);
  let t0;
  if ($[0] !== setCategory) {
    t0 = async function onSelectCategory(value) {
      await setCategory(value ? toLowerCase(value) : null);
    };
    $[0] = setCategory;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onSelectCategory = t0;
  let t1;
  if ($[2] !== category) {
    t1 = category ? toUpperCase(category) : undefined;
    $[2] = category;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== onSelectCategory || $[5] !== t1) {
    t2 = {
      category: t1,
      onSelectCategory
    };
    $[4] = onSelectCategory;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}